<template>
    <div v-if="!_.isEmpty(toolbarConfig)" :class="['content-toolbar', 'mb-3','text-right', parent ? 'has-parent' : 'no-parent']">
        <template v-if="componentName == 'table-component'">
            <template v-for="item in toolbarConfig">
                <button type="button"
                    v-if="item.name == 'create'"
                    v-on:click="onCreating"
                    class="btn btn-rounded btn-success btn-sm btn-icon mr-2"
                    ><i class="material-icons">add</i>{{ item.label || 'Add ' + __(content.type, ['singular', 'titleCase'])}}</button>
                <button type="button"
                    v-if="item.name == 'export'"
                    v-on:click="exportToCsv(item)"
                    :class="['btn', 'btn-rounded', 'btn-primary', 'btn-sm', 'btn-icon', 'mr-2']"
                    :disabled="exporting">
                    <i v-if="exporting" class="material-icons">refresh</i>
                    <i v-else class="material-icons">get_app</i>
                    {{ item.label || 'Export ' + __(content.type, ['plural', 'titleCase']) }}
                </button>
                <component
                    v-if="item.component"
                    :is="item.component"
                    :helpers="helpers"
                    :addNotification="addNotification"
                    :config="item"
                    :content="content"

                    :createData="createData"
                    :updateData="updateData"
                    :deleteData="deleteData"
                    :updateBatch="updateBatch"
                    ></component>
            </template>
        </template>
        <template v-if="componentName == 'form-component'">
            <template v-for="item in toolbarConfig">

                <button type="button"
                    v-on:click="submit"
                    v-if="isCreating && item.name == 'edit'"
                    :disabled="submitting || !dirty"
                    :class="['btn', 'btn-rounded', 'btn-icon', 'btn-sm', 'btn-success', 'mr-sm-2']">
                    <i class="material-icons">save</i>{{ submitting ? 'Saving...' : 'Save' }}</button>

                <button type="button"
                    v-on:click="addNew"
                    v-if="isEditing && !children && item.name == 'add'"
                    :disabled="submitting"
                    :class="['btn', 'btn-rounded', 'btn-icon', 'btn-sm', 'btn-success', 'mr-sm-2']">
                    <i class="material-icons">add</i>Add new</button>

                <button type="button"
                    v-on:click="submit"
                    v-if="isEditing && !children && item.name == 'edit'"
                    :disabled="submitting || !dirty"
                    :class="['btn', 'btn-rounded', 'btn-icon', 'btn-sm', 'btn-primary', 'mr-sm-2']">
                    <i class="material-icons">save</i>{{ submitting ? 'Saving...' : 'Save' }}</button>

                <button type="button"
                    v-on:click="deleteItem"
                    v-if="isEditing && item.name == 'delete'"
                    :disabled="submitting || _.get(content, 'meta.protected')"
                    :class="['btn', 'btn-trans', 'ml-sm-2']">
                    <i class="material-icons">delete_outline</i></button>

                <button type="button"
                    v-on:click="publish"
                    v-if="publishable && item.name == 'publish'"
                    :disabled="submitting || !canPublish"
                    :class="['btn', 'btn-rounded', 'btn-icon', 'btn-sm', 'btn-success', 'ml-sm-2']">
                    <i class="material-icons">cloud_upload</i>Publish</button>

                <span v-if="item.name == 'separator'"
                    :class="['btn-separator', 'ml-sm-2']"></span>

                <button type="button"
                    v-on:click="preview"
                    v-if="viewable && item.name == 'preview'"
                    :class="['btn','btn-trans', 'ml-3']">
                    <i class="material-icons">remove_red_eye</i></button>

                <switches
                    v-model="localActive"
                    v-on:input="toggleActive"
                    v-if="hasStatus && item.name == 'active'"
                    :class="['ml-sm-2']"
                    :disabled="submitting || isReadonly('active')"></switches>

                <component
                    v-if="item.component"
                    :is="item.component"
                    :helpers="helpers"
                    :addNotification="addNotification"
                    :content="content"
                    :config="item"
                    :createData="createData"
                    :updateData="updateData"
                    :deleteData="deleteData"
                    :updateBatch="updateBatch"
                    ></component>
            </template>
        </template>
    </div>
</template>
<script>
import Vue from 'vue';
import V from 'voca';
import _ from 'lodash';
import Switches from '../form-elements/CustomSwitchComponent';
import { plural, singular } from 'pluralize';
import { convertArrayToCSV } from 'convert-array-to-csv';

export default {
    data() {
        const active = _.get(this.content, 'meta.active');
        return {
            currentRevision: null,
            localActive: active,
            submitting: false,
            exporting: false,
        }
    },

    props: [
        'content', 'parent', 'children', 'contentErrors', 'timestamp', 'dirty',
        'changeUrl', 'changeQuery', 'changeSection', 'haltFetch',
        'createData', 'updateData', 'deleteData', 'updateBatch',
        'componentName', 'componentConfig', 'parentConfig',
        'commitQueue', 'addNotification',
    ],

    components: {
        Switches,
    },

    watch: {
        timestamp(val) {

        },
        dirty(newVal) {

        },
        parent(newVal) {
            this.$forceUpdate();
        },
        active(newVal) {
            this.localActive = newVal;
        },
    },

    computed: {
        config() {
            return this.componentConfig || {};
        },

        toolbarConfig() {
            return _.get(this.componentConfig, 'toolbar', [])
                .map(item => {
                    if (_.isObject(item)) return item;

                    return {
                        name: item,
                    }
                })
        },

        meta() {
            return this.content.meta || {};
        },

        revisions() {
            let revisions = this.meta.versions || [];
            revisions = [
                { value: '', text: 'draft' },
                ...revisions.map(rev => ({ value: rev.id, text: rev.created_at })),
            ];
            return revisions;
        },

        isCreating() {
            return Boolean(this.content && this.content.attributes && !this.content.id);
        },

        isEditing() {
            return Boolean(this.content && this.content.attributes && this.content.id);
        },

        // content status control section
        hasStatus() {
            return _.has(this.content, 'meta.active');
        },

        active() {
            return !this.isCreating && _.get(this.content, 'meta.active');
        },

        viewable() {
            return !this.isCreating && _.has(this.content, 'meta.preview');
        },

        publishable() {
            return !this.isCreating && _.has(this.content, 'meta.published');
        },

        published() {
            return _.get(this.content, 'meta.published');
        },

        canPublish() {
            return this.publishable && !this.published;
        },
    },

    mounted() {
        console.log('Component mounted.')
    },

    destroyed() {

    },

    methods: {
        changeRevision(id) {
            this.changeQuery({
                rev: id
            });
        },

        submit() {
            this.submitting = true;
            const submitHandler = _.get(this.config, 'submit');

            // call submit function that is passed from the form
            if (submitHandler) {
                return submitHandler()
                    .then(() => {
                        this.submitting = false;
                        this.$forceUpdate();
                    })
            }

            const data = this.content.attributes;
            const fieldErrorPairs = _.toPairs(this.contentErrors);
            if (fieldErrorPairs.length > 0) {
                return this.addNotification({
                    type: 'error',
                    message: fieldErrorPairs.map(([field, error]) => `${V.capitalize(field).replace('_', ' ')}: ${error}`),
                })
            }

            if (this.isCreating) {
                this.haltFetch();
                this.createData(data, { setNotification: true, updateRoute: true })
                    .then(() => {
                        this.submitting = false;
                        this.onCreated(this.type, data);
                    });
            } else {
                this.updateData(data, { setNotification: true })
                    .then(() => this.commitQueue())
                    .then(() => {
                        this.submitting = false;
                        this.onUpdated(this.type, data)
                    });
            }
        },

        deleteItem() {
            const type = _.chain(this.content).get('type', 'content').split('.').first().replace(/[\-\_]/, ' ').value();
            const status = confirm(`Are you sure to delete this ${type}?`);
            return status && this.deleteData({ setNotification: true })
                .then(() => this.onDeleted(this.type));
        },

        addNew() {
            const newLink = _.get(this.content, 'links.self', '').replace(`/${this.content.id}`, '/_');

            const uriFormat = this.helpers('uriFormat');

            if (newLink) {
                this.changeUrl(uriFormat(newLink));
            }
        },

        activate() {
            this.updateData({ active: 1, }, { setNotification: true });
        },

        deactivate() {
            this.updateData({ active: 0, }, { setNotification: true });
        },

        toggleActive(value) {
            if (value == this.active) return;
            return this.updateData({ active: value }, { setNotification: true });
        },

        publish() {
            this.updateData({ publish: 1, }, { setNotification: true });
        },

        resolveDataToExport(config) {
            let endpoint = _.get(config, 'endpoint');
            const api = this.helpers('api');

            if (endpoint) {
                try {
                    endpoint = _.isFunction(endpoint) ? endpoint(this.content) : endpoint;
                    const uriFormat = this.helpers('uriFormat');
                } catch (e) {
                    return Promise.reject(e);
                }

                return api.getData(
                    _.get(endpoint, 'path', '/'),
                    _.get(endpoint, 'query', {})
                );
            }

            return Promise.resolve(this.content);
        },

        exportToCsv(config) {
            this.exporting = true;
            this.addNotification({
                type: 'message',
                message: 'Exporting, please wait...'
            });

            return this.resolveDataToExport(config)
                .then((content) => {
                    const type = _.get(content, 'type', 'data');
                    const formatter = _.get(config, 'formatter');
                    const filter = _.get(config, 'filter');

                    const data = _.chain(content)
                        .get('data', [])
                        .filter(item => (filter ? filter(item) : true))
                        .map(item => (formatter ? formatter(item) : {
                            id: item.id,
                            type: item.type,
                            ...item.attributes,
                            ...item.meta,
                        }))
                        .value();

                    const csv = convertArrayToCSV(data);

                    const hiddenElement = document.createElement('a');
                    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                    const url = URL.createObjectURL(blob);

                    hiddenElement.href = url;
                    hiddenElement.target = '_blank';
                    hiddenElement.download = `${type}.csv`;
                    hiddenElement.click();
                    this.exporting = false;
                })
                .catch((e) => {
                    this.addNotification({
                        type: 'error',
                        message: e.message,
                    });
                    this.exporting = false;
                })
        },

        preview() {
            window.open(`/admin/_embed_/?url=${this.content.meta.preview}${window.location.hash}`, '_blank');
        },

        isReadonly(field) {
            return _.get(this.content, 'meta.readonly', []).indexOf(field) >= 0;
        },

        onDeleted() {
            this.$emit('content::deleted', this.content);
        },

        onUpdated() {
            this.currentRevision = '';
            this.changeQuery({});
            this.$emit('content::updated', this.content)
        },

        onCreating() {
            this.$emit('content::creating', {
                type: this.content.schema.instanceType,
                attributes: {},
                meta: {},
                schema: this.content.schema,
            })
        },

        onCreated() {
            this.$emit('content::created', this.content);
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/helpers/ContentToolbarComponent.vue